<template>
  <div class="feedback">
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column prop="nickname" label="用户名"> </el-table-column>
      <el-table-column prop="contact" label="联系方式"> </el-table-column>
      <el-table-column prop="cityPathName" label="满意度">
        <template slot-scope="{ row }">
          <div class="face">
            <p v-for="(item, index) in feedbackList" :key="index">
              <img
                :src="
                  index <= row.satisfactionLevel - 1 ? item.active : item.icon
                "
                alt=""
              />
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="问题描述" prop="problemDescription">
      </el-table-column>
      <el-table-column prop="createdTime" label="创建时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该反馈吗？"
            popper-class="customerdel-popover"
            @confirm="cancelOrder(scope.row)"
          >
            <el-button class="textOrange-btn" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination
      v-show="total > queryParams.pageSize"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="init"
    />
  </div>
</template>

<script>
import { getFeedback, deleteAgreement } from "@/api/login";

export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0, //总数
      feedbackList: [
        {
          icon: require("@/assets/feedback/1.png"),
          active: require("@/assets/feedback/1_active.png"),
        },
        {
          icon: require("@/assets/feedback/2.png"),
          active: require("@/assets/feedback/2_active.png"),
        },
        {
          icon: require("@/assets/feedback/3.png"),
          active: require("@/assets/feedback/3_active.png"),
        },
        {
          icon: require("@/assets/feedback/4.png"),
          active: require("@/assets/feedback/4_active.png"),
        },
        {
          icon: require("@/assets/feedback/5.png"),
          active: require("@/assets/feedback/5_active.png"),
        },
      ],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取反馈列表
    async init() {
      const res = await getFeedback(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 删除协议
    async cancelOrder(item) {
      // console.log(item, status, index);
      const params = {
        agreementName: item.agreementName,
        id: item.id,
      };
      await deleteAgreement(params);
      this.$message.success("协议删除成功");
      // this.$refs[`popover-${index}`].doClose();
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.feedback {
  .face {
    display: flex;
    align-items: center;
    justify-content: space-around;
    p {
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
